import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import EditorialMarquee from "../components/Marquee";
import Manifesto from "../components/Manifesto";
import ScamWatch from "../components/ScamWatch";
import BrandSearch from "../components/BrandSearch";
import Quiz from "../components/Quiz";
import Calculator from "../components/Calculator";
import Directory from "../components/Directory";
import Independence from "../components/Independence";
import Reviews from "../components/Reviews";
import Templates from "../components/Templates";
import Pricing from "../components/Pricing";
import AppSection from "../components/AppSection";
import Referral from "../components/Referral";
import Consult from "../components/Consult";
import Footer from "../components/Footer";

export default function Landing() {
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) sessionStorage.setItem("referral_code", ref);
  }, []);

  return (
    <div data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <ScamWatch />
        <BrandSearch />
        <Quiz />
        <Calculator />
        <Directory />
        <Independence />
        <Reviews />
        <Templates />
        <Pricing />
        <AppSection />
        <Referral />
        <Consult />
      </main>
      <Footer />
    </div>
  );
}
